import clsx from 'clsx';
import { Button } from 'components/common';
import { Title } from '../title';
import { customEvent } from '@/lib';
import AppRoutes from '@/const/routes';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Images from '@/const/images';

interface Props {
	className?: string;
	classNameContainer?: string;
	classNameTextContainer?: string;
}

export const GetStarted: React.FC<Props> = ({
	className,
	classNameContainer,
	classNameTextContainer,
}) => {
	const { pathname } = useRouter();
	const router = useRouter();
	const showHat = pathname === '/cases';

	return (
		<div
			className={clsx(
				'h-full px-5 lg:px-0 pb-[49px] mt-14 md:mt-[80px] lg:mt-0 relative',
				className
			)}
		>
			<div
				className={clsx(
					"xl:bg-[url('/img/landing/lines-green.png')] bg-contain",
					' bg-no-repeat bg-left-top min-h-[250px] lg:h-[387px] xl:h-[573px] 2xl:min-h-[630px]',
					'flex justify-center',
					classNameContainer
				)}
			>
				<div
					className={clsx(
						'flex flex-col items-center justify-center',
						'xl:mt-4 2xl:mt-0 3xl:mt-5',
						'mt-0',
						classNameTextContainer
					)}
				>
					<Title
						description="See if you qualify—it's fast, easy and free"
						className="md:mt-4 gap-6 md:gap-8"
						typographyDescription="regular-28"
						classNameDescription={'!text-[30px]'}
					>
						<span className="text-primary">Claim</span> What&apos;s Yours
					</Title>
					<Button
						decoration="primary"
						size="large"
						className="mt-6 md:mt-8 !w-full md:!w-[197px] !h-12 md:!h-16"
						onClick={() => {
							customEvent({
								action: 'explore_all_cases_click',
								category: 'landing',
								label: 'Explore All Cases',
								value: 'Explore All Cases',
								callback: async () => {
									router.push(AppRoutes.LANDING_CASES);
								},
							});
						}}
					>
						Get Started Today
					</Button>
				</div>
			</div>

			<div
				className={clsx(
					'hidden xl:block absolute right-0 top-[50px] 3xl:top-[90px]',
					{
						'!hidden': !showHat,
					}
				)}
			>
				<Image
					src={Images.hatCut}
					alt="hat"
					width={0}
					height={0}
					sizes="100vw"
					className="w-full h-full"
					quality={75}
					priority
				/>
			</div>
		</div>
	);
};
